// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".function {\n  background: var(--primary-bg-color);\n}\n.function_main {\n  width: 1280px;\n  margin: 0 auto;\n}\n.function_main_title {\n  padding-top: 60px;\n}\n.function_main_list {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding: 60px 0 77px;\n}\n", ""]);
// Exports
exports.locals = {
	"sideBarWidth": "210px",
	"appHeaderHeight": "60px",
	"interval": "16px"
};
module.exports = exports;
